import { Breakpoint, SideMenu, TopMenu } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex } from '../../enums';
import { Color } from '../../theme';

import { RightWrapperProps } from './appWrapper.types';

export const Container = styled.div``;

export const RightWrapper = styled.div<RightWrapperProps>`
  transition: .3s;

  @media ${Breakpoint.SmallDesktop} {
    margin-left: ${({ $withLeftSpace }: RightWrapperProps): string => $withLeftSpace ? '80px' : '0'};
    width: ${({ $withLeftSpace }: RightWrapperProps): string => $withLeftSpace ? 'calc(100% - 80px)' : '100%'};
  }
`;

export const MainContent = styled.div`
  min-height: 30vh;
  display: flex;
  flex-direction: column;

  @media ${Breakpoint.Tablet} {
    min-height: calc(100vh - 177px - 80px);
  }
`;

export const RemainingPlace = styled.div`
  background-color: ${Color.almostWhite};
  flex-grow: 1;
`;

export const StyledTopMenu = styled(TopMenu)`
  position: relative;
  z-index: ${AppZIndex.TopMenu};
`;

export const StyledSideMenu = styled(SideMenu)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: ${AppZIndex.SideMenu};
`;
